import { quickEntries } from "@/mocks/home";

const toneMap: Record<string, string> = {
  primary: "bg-primary-100 text-primary-700",
  accent: "bg-accent-100 text-accent-700",
  secondary: "bg-secondary-100 text-secondary-700",
};

export default function Hero() {
  const go = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section id="top" className="relative overflow-hidden border-b border-background-200">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20warm%20paper%20texture%20background%20with%20soft%20orange%20and%20crimson%20ink%20brush%20strokes%2C%20minimal%20artistic%20comic%20panel%20inspired%20design%2C%20generous%20empty%20negative%20space%20on%20the%20left%2C%20clean%20editorial%20aesthetic&width=1920&height=1080&seq=laosiji-hero-bg-01&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-background-50 via-background-50/92 to-background-50/70"></div>
      </div>

      <div className="relative w-full px-4 md:px-6 pt-8 md:pt-12 pb-12 md:pb-16">
        <div className="hidden md:flex items-center gap-3 mb-6">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-secondary-100 text-secondary-800 text-xs font-label">
            <i className="ri-checkbox-circle-line"></i>
            入口 / 地址 / 下载 · 一站式说明
          </span>
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-100 border border-background-200 text-foreground-600 text-xs font-label">
            <i className="ri-time-line"></i>
            内容维护至 2026-10-10
          </span>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-10 items-start">
          <div className="lg:col-span-7 animate-fade-up">
            <h1 className="font-heading font-black text-foreground-950 text-3xl md:text-4xl lg:text-[2.75rem] leading-[1.25] md:leading-[1.2]">
              老司机漫画官网入口在哪？最新地址、APP下载与在线看网址一次讲清
            </h1>
            <p className="mt-5 text-foreground-700 text-base md:text-lg leading-relaxed max-w-2xl">
              很多人反复搜索「老司机漫画官网」，真正卡住的其实是三件事：
              <strong className="text-foreground-900 font-semibold">入口怎么找、地址变了怎么办、APP 该从哪下载</strong>。
              这一页把入口、最新地址、下载方式与在线看网址集中在一处，帮你少走弯路、一步到位。
            </p>

            <div className="mt-7 flex flex-wrap items-center gap-3">
              <button
                onClick={() => go("entry-channel")}
                className="inline-flex items-center gap-2 px-5 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-label whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
              >
                <i className="ri-compass-3-line text-base"></i>
                先看官网入口
              </button>
              <button
                onClick={() => go("app")}
                className="inline-flex items-center gap-2 px-5 py-3 rounded-md bg-background-50 border border-background-300 text-foreground-800 text-sm font-label whitespace-nowrap hover:border-primary-300 hover:text-primary-700 transition-colors cursor-pointer"
              >
                <i className="ri-download-2-line text-base"></i>
                跳到 APP 下载
              </button>
            </div>

            <div className="mt-8 flex flex-wrap gap-x-8 gap-y-3 text-sm font-label text-foreground-600">
              <span className="inline-flex items-center gap-2">
                <i className="ri-stack-line text-primary-500"></i> 四类入口对照
              </span>
              <span className="inline-flex items-center gap-2">
                <i className="ri-shield-check-line text-accent-500"></i> 真假站点判断
              </span>
              <span className="inline-flex items-center gap-2">
                <i className="ri-question-answer-line text-secondary-500"></i> 8 条常见问题
              </span>
            </div>
          </div>

          <div className="lg:col-span-5">
            <div className="rounded-lg border border-background-200 bg-background-50/95 backdrop-blur p-5 md:p-6">
              <div className="flex items-center justify-between mb-4">
                <h2 className="font-heading font-bold text-foreground-950 text-lg">核心信息速览</h2>
                <span className="text-xs font-label text-foreground-500">点选直达</span>
              </div>
              <div className="space-y-2.5">
                {quickEntries.map((item) => (
                  <button
                    key={item.id}
                    onClick={() => go(item.id)}
                    className="w-full text-left flex items-start gap-3 p-3 rounded-md bg-background-100/80 hover:bg-background-200/70 transition-colors cursor-pointer"
                  >
                    <span
                      className={`w-10 h-10 rounded-md flex items-center justify-center shrink-0 ${toneMap[item.tone]}`}
                    >
                      <i className={`${item.icon} text-lg`}></i>
                    </span>
                    <span className="min-w-0">
                      <span className="flex items-center gap-1.5 font-label font-medium text-foreground-900 text-sm">
                        {item.title}
                        <i className="ri-arrow-right-s-line text-foreground-400"></i>
                      </span>
                      <span className="block mt-1 text-xs text-foreground-600 leading-relaxed">
                        {item.desc}
                      </span>
                    </span>
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}